import React, { useMemo } from "react";

interface TreeNode {
  id: number;
  name: string;
  level: "Beat" | "SubBeat" | "Job Title";
  children: TreeNode[];
}

interface SelectedItem {
  id: number;
  name: string;
}

const ExpertiseTreeView = ({
  expertiseTree,
  selectedExpertiseIds,
}: {
  expertiseTree: TreeNode[];
  selectedExpertiseIds: SelectedItem[];
}) => {
  const selectedIds = new Set(selectedExpertiseIds.map((x) => x.id));

  return (
    <>
      {expertiseTree.map((beat) => {
        const subBeats = beat.children
          .map((sub) => {
            const jobs = sub.children.filter((job) =>
              selectedIds.has(job.id)
            );

            if (selectedIds.has(sub.id) || jobs.length > 0) {
              return { ...sub, jobs };
            }

            return null;
          })
          .filter(Boolean);

        if (!selectedIds.has(beat.id) && subBeats.length === 0) {
          return null;
        }

        return (
          <div
            key={beat.id}
            style={{
              background: "#E8F2FF",
              border: "1px solid #BFDBFE",
              borderRadius: 8,
              padding: 10,
              marginBottom: 10,
            }}
          >
            {/* Beat */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontWeight: 700,
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: "#2563EB",
                }}
              />
              {beat.name}
            </div>

            {subBeats.map((sub: any) => (
              <div
                key={sub.id}
                style={{
                  background: "#F8FBFF",
                  borderRadius: 6,
                  padding: 8,
                  marginBottom: 6,
                }}
              >
                {/* SubBeat */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    fontWeight: 600,
                    fontSize: 12,
                    marginBottom: 6,
                  }}
                >
                  <span
                    style={{
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      background: "#60A5FA",
                    }}
                  />
                  {sub.name}
                </div>

                {/* Job Titles */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 6,
                  }}
                >
                  {sub.jobs.map((job: TreeNode) => (
                    <div
                      key={job.id}
                      style={{
                        background: "#FFF",
                        border: "1px solid #BFDBFE",
                        borderRadius: 16,
                        padding: "4px 10px",
                        fontSize: 12,
                      }}
                    >
                      {job.name}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        );
      })}
    </>
  );
};

export default ExpertiseTreeView;